var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"app-links"},[_c('router-link',{attrs:{"to":{ name: 'Hello' }}},[_vm._v("Aide")]),_vm._v(" "),_c('router-link',{attrs:{"to":{ name: 'Associate' }}},[_vm._v("Associate")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/edit/1234"}},[_vm._v("Edit")])],1),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e02d88c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 